import { Typography } from '@mui/material'
import { Box } from '@mui/material'

import ObjectAvatar from 'src/components/ObjectAvatar/ObjectAvatar'
import Row from 'src/components/Row/Row'
import { buildGqlObject, searchMetadataBuilders } from 'src/lib/Objects/build'

import useSidebar from './useSidebar'

const SidebarHeader = () => {
  const { object } = useSidebar()
  const metadata = searchMetadataBuilders[object.objectType](object)
  const gqlObject = buildGqlObject(object)

  return (
    metadata && (
      <Row className="header-row">
        <Row
          gap={2}
          sx={{ pt: 2 }}
        >
          <ObjectAvatar crmObject={gqlObject} />
          <Box>
            <Row className="object-title-row">
              <Row gap={1}>
                <Typography variant="h2">{metadata.label}</Typography>
                <Row className="sidebar-links-row"></Row>
              </Row>
            </Row>
            <Typography className="description">
              {metadata.description}
            </Typography>
          </Box>
        </Row>
      </Row>
    )
  )
}

export default SidebarHeader
